"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IColonyFactory_1 = require("../../contracts/4/IColonyFactory");
const constants_1 = require("../../constants");
const extensionsV4_1 = require("./extensions/extensionsV4");
function getColonyClient(address, signerOrProvider) {
    const colonyClient = IColonyFactory_1.IColonyFactory.connect(address, signerOrProvider);
    colonyClient.clientVersion = constants_1.ColonyVersion.BurgundyGlider;
    extensionsV4_1.addExtensions(colonyClient, this);
    return colonyClient;
}
exports.default = getColonyClient;
